<template>
  <div class="tpl-history">
    <div class="tpl-panel">
      <div class="tpl-head">
        <Icon type="ios-list-box-outline" class="tpl-head-icon" />
        <span class="tpl-head-title">历史查询模版</span>
      </div>
      <p class="tpl-head-desc">管理和使用已保存的自定义查询模版，支持一键执行查询、编辑配置或删除</p>

      <div class="tpl-search">
        <Input v-model="keyword" placeholder="搜索模版名称、主表名称、描述..." class="tpl-search-input" @on-enter="onSearch" />
        <Button type="primary" icon="ios-search" @click="onSearch">搜索</Button>
        <Button class="tpl-reset" icon="md-refresh" @click="onReset">重置</Button>
      </div>
      <Table :height="tableHeight" :columns="columns" :data="rows" :loading="loading" stripe></Table>

      <div class="tpl-page">
        <span class="tpl-total">共 {{ total }} 条记录</span>
        <Page :total="total" :current="pageNo" :page-size="pageSize" @on-change="onPageChange" size="small" show-elevator />
      </div>
    </div>

    <!-- 查看脚本 -->
    <script-modal v-model="scriptModalShow" :api="api" :app-id="appId" :query-json="scriptQueryJson" />
  </div>
</template>

<script>
import scriptModal from '../components/script-modal.vue'

export default {
  name: 'template-history',
  components: { scriptModal },
  props: {
    api: {
      type: Object,
      required: true
    },
    appId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      keyword: '',
      loading: false,
      rows: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      tableHeight: 500, // 表格可视高度(px)，固定表头并出现纵向滚动条；随窗口自适应
      scriptModalShow: false, // 查看脚本弹窗
      scriptQueryJson: '', // 传给脚本弹窗的查询配置
      columns: [
        { title: '模版名称', key: 'name', minWidth: 140, tooltip: true },
        { title: '描述', key: 'description', minWidth: 180, tooltip: true },
        {
          title: '主表名称',
          key: 'mainTableName',
          width: 230,
          render: (h, { row }) => h('span', { class: 'tpl-tag' }, row.mainTableName)
        },
        {
          title: '查询条件',
          key: 'queryCondition',
          minWidth: 220,
          // 不同搜索条件换行展示
          render: (h, { row }) =>
            h(
              'div',
              String(row.queryCondition || '')
                .split('\n')
                .filter(Boolean)
                .map(item => h('div', { class: 'tpl-cond-item' }, item))
            )
        },
        { title: '创建时间', key: 'createTime', width: 200 },
        {
          title: '操作',
          key: 'action',
          width: 400,
          align: 'center',
          render: (h, { row }) => {
            return h('div', [
              h('Button', { props: { type: 'success', size: 'small', icon: 'md-play' }, style: { marginRight: '6px' }, on: { click: () => this.$emit('execute', row) } }, '执行查询'),
              h('Button', { props: { type: 'primary', size: 'small', icon: 'md-create' }, style: { marginRight: '6px' }, on: { click: () => this.$emit('edit', row) } }, '编辑'),
              h('Button', { props: { type: 'error', size: 'small', icon: 'md-close' }, style: { marginRight: '6px' }, on: { click: () => this.onDelete(row) } }, '删除'),
              h('Button', { props: { type: 'info', size: 'small', icon: 'md-eye' }, on: { click: () => this.lookScript(row) } }, '查看脚本')
            ])
          }
        }
      ]
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.updateTableHeight()
    window.addEventListener('resize', this.updateTableHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateTableHeight)
  },
  methods: {
    // 计算表格可视高度(约占视口 78%)，iView Table 的 height 需为像素数值方可固定表头并出现滚动条
    updateTableHeight () {
      this.tableHeight = Math.round(window.innerHeight * 0.78)
    },
    getData () {
      this.loading = true
      this.api
        .getTemplatePage({ searchValue: this.keyword, pageNo: this.pageNo, pageSize: this.pageSize })
        .then(resp => {
          this.rows = resp.rows || []
          this.total = resp.total || 0
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onSearch () {
      this.pageNo = 1
      this.getData()
    },
    onReset () {
      this.keyword = ''
      this.pageNo = 1
      this.getData()
    },
    onPageChange (pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    onDelete (row) {
      this.$Modal.confirm({
        title: '确认删除模版',
        content: '确定要删除模版 "' + row.templateName + '" 吗？<br/>此操作不可恢复，删除后该模版的配置将永久丢失。',
        okText: '确认删除',
        cancelText: '取消',
        loading: true,
        onOk: () => {
          this.api.deleteTemplate(row.id, row.templateName).then(resp => {
            this.$Modal.remove()
            if (resp && resp.success) {
              this.$Message.success('删除成功')
              if (this.rows.length === 1 && this.pageNo > 1) {
                this.pageNo -= 1
              }
              this.getData()
            } else {
              this.$Message.error('删除失败')
            }
          })
        }
      })
    },
    lookScript (row) {
      // 用模板保存的查询配置（queryConfig 即 queryJson）获取脚本
      this.scriptQueryJson = (row && row.queryConfig) || ''
      this.scriptModalShow = true
    }
  }
}
</script>

<style lang="less" scoped>
.tpl-history {
  padding: 12px;
}
.tpl-panel {
  background: #fff;
  border-radius: 4px;
  padding: 16px 20px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.tpl-head {
  display: flex;
  align-items: center;
}
.tpl-head-icon {
  font-size: 22px;
  color: #2b5fd9;
  margin-right: 8px;
}
.tpl-head-title {
  font-size: 18px;
  font-weight: 600;
}
.tpl-head-desc {
  color: #999;
  font-size: 12px;
  margin: 6px 0 16px;
}
.tpl-search {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.tpl-search-input {
  width: 360px;
  margin-right: 8px;
}
.tpl-reset {
  margin-left: auto;
}
.tpl-page {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}
.tpl-total {
  color: #666;
  font-size: 13px;
}
/deep/ .tpl-tag {
  display: inline-block;
  padding: 2px 10px;
  background: #e8fff3;
  color: #19be6b;
  border-radius: 12px;
  font-size: 12px;
}
/deep/ .tpl-cond-item {
  color: #2b5fd9;
  font-size: 12px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/custom-query/views/template-history.vue